import React from 'react';
import FilterChip from 'components/admin/search/FilterChip';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

type FilterDisplayMap = Record<string, (value: any) => string>;

interface FilterChipsProps {
  displayMap?: FilterDisplayMap;
  isSearchComplete?: boolean;
  className?: string;
}

export const FilterChips: React.FC<FilterChipsProps> = ({ displayMap = {}, isSearchComplete = false, className }) => {
  const { values, setFieldValue, submitForm } = useFormikContext<any>();

  const removeFilter = (key: string) => {
    const currentValue = values[key];
    const resetValue = typeof currentValue === 'boolean' ? false : '';
    setFieldValue(key, resetValue);
    if (isSearchComplete) {
      submitForm();
    }
  };

  const getDisplayValue = (key: string, value: any): string => {
    const displayFn = displayMap[key];
    return displayFn ? displayFn(value) : String(value);
  };

  return (
    <div className={`flex flex-wrap gap-2 ${className ?? ''}`}>
      {Object.entries(values)
        .filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        .map(([key, val]) => {
          const display = getDisplayValue(key, val);

          if (!display) {
            return null;
          }

          return <StyledChip text={display} onClick={() => removeFilter(key)} />;
        })}
    </div>
  );
};

const StyledChip = styled(FilterChip)`
  margin: 0.25rem;
`;
